/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Noupcomingevents2Inputs */

const en_noupcomingevents2 = /** @type {(inputs: Noupcomingevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No upcoming events`)
};

const de_noupcomingevents2 = /** @type {(inputs: Noupcomingevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine kommenden Events`)
};

/**
* | output |
* | --- |
* | "No upcoming events" |
*
* @param {Noupcomingevents2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const noupcomingevents2 = /** @type {((inputs?: Noupcomingevents2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Noupcomingevents2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_noupcomingevents2(inputs)
	return de_noupcomingevents2(inputs)
});
export { noupcomingevents2 as "noUpcomingEvents" }